import IMG01 from '../../assets/images/notes/1.jpg'
import IMG02 from '../../assets/images/notes/2.jpg'
import IMG03 from '../../assets/images/notes/3.jpg'
import IMG04 from '../../assets/images/notes/4.jpg'
import IMG05 from '../../assets/images/notes/5.jpg'
import IMG06 from '../../assets/images/notes/6.jpg'
import IMG07 from '../../assets/images/notes/7.jpg'
import IMG08 from '../../assets/images/notes/8.jpg'
import IMG09 from '../../assets/images/notes/9.jpg'
import IMG10 from '../../assets/images/notes/10.jpg'

import IMG11 from '../../assets/images/notes/11.jpg'
import IMG12 from '../../assets/images/notes/12.jpg'
import IMG13 from '../../assets/images/notes/13.jpg'

export const HOME_NOTES = [
  {
    image: IMG11,
    title: 'notes.notes.title11',
    description: 'notes.notes.description11',
    author: 'Michelle Carrere (Mongabay Latam)',
    date: '18-03-2026',
    link_es:
      'https://www.elclip.org/el-gobierno-de-kast-frena-las-areas-protegidas-en-salares-aprobadas-por-boric-y-otras-37-normas-y-reglamentos-ambientales/',
    link_pt:
      'https://www.elclip.org/el-gobierno-de-kast-frena-las-areas-protegidas-en-salares-aprobadas-por-boric-y-otras-37-normas-y-reglamentos-ambientales/',
    link_en:
      'https://www.elclip.org/el-gobierno-de-kast-frena-las-areas-protegidas-en-salares-aprobadas-por-boric-y-otras-37-normas-y-reglamentos-ambientales/',
  },
  {
    image: IMG01,
    title: 'notes.notes.title1',
    description: 'notes.notes.description1',
    author: 'Barinia Montoya (Mongabay Latam)',
    date: '12-03-2026',
    link_es:
      'https://www.elclip.org/chile-litio-salares-inversion/',
    link_pt:
      'https://www.elclip.org/chile-litio-salares-inversion/',
    link_en:
      'https://www.elclip.org/chile-litio-salares-inversion/',
  },
  {
    image: IMG02,
    title: 'notes.notes.title2',
    description: 'notes.notes.description2',
    author: 'Barinia Montoya (Mongabay Latam)',
    date: '02-02-2026',
    link_es:
      'https://www.elclip.org/la-carrera-de-chile-contra-el-reloj-para-proteger-sus-salares/',
    link_pt:
      'https://www.elclip.org/la-carrera-de-chile-contra-el-reloj-para-proteger-sus-salares/',
    link_en:
      'https://www.elclip.org/la-carrera-de-chile-contra-el-reloj-para-proteger-sus-salares/?lang=en',
  },
  {
    image: IMG03,
    title: 'notes.notes.title3',
    description: 'notes.notes.description3',
    author: 'Maximiliano Manzoni (Consenso / Climate Tracker) y Andrés Bermúdez Liévano (CLIP)',
    date: '30-10-2025',
    link_es:
      'https://www.elclip.org/la-misteriosa-empresa-que-quiere-extender-el-triangulo-del-litio-a-paraguay/',
    link_pt:
      'https://www.elclip.org/la-misteriosa-empresa-que-quiere-extender-el-triangulo-del-litio-a-paraguay/',
    link_en:
      'https://www.elclip.org/la-misteriosa-empresa-que-quiere-extender-el-triangulo-del-litio-a-paraguay/?lang=en',
  },
  {
    image: IMG04,
    title: 'notes.notes.title4',
    description: 'notes.notes.description4',
    author:
      'Isabel Harari (Repórter Brasil), Andrés Bermúdez Liévano (CLIP), Kuek Ser Kuang Keng y Jelter Meers (Pulitzer Center)',
    date: '30-10-2025',
    link_es:
      'https://www.elclip.org/litio-brasileno-se-volvio-carbono-neutral-con-proyecto-de-carbono-con-sospechas-de-deforestacion/',
    link_pt:
      'https://reporterbrasil.org.br/2025/10/sigma-litio-quintuplo-zero-credito-carbono-desmatamento/',
    link_en:
      'https://www.elclip.org/litio-brasileno-se-volvio-carbono-neutral-con-proyecto-de-carbono-con-sospechas-de-deforestacion/?lang=en',
  },
  /*{
    image: IMG12,
    title: 'notes.notes.title12',
    description: 'notes.notes.description12',
    author: 'Isabel Harari (Repórter Brasil), Andrés Bermúdez Liévano (CLIP), Kuek Ser Kuang Keng e Jelter Meers (Pulitzer Center) | Edição Diego Junqueira',
    date: '30-10-2025',
    link_es:
      'https://reporterbrasil.org.br/2025/10/sigma-litio-quintuplo-zero-credito-carbono-desmatamento/',
    link_pt:
      'https://reporterbrasil.org.br/2025/10/sigma-litio-quintuplo-zero-credito-carbono-desmatamento/',
    link_en:
      'https://reporterbrasil.org.br/2025/10/sigma-litio-quintuplo-zero-credito-carbono-desmatamento/',
  },*/
  {
    image: IMG13,
    title: 'notes.notes.title13',
    description: 'notes.notes.description13',
    author: 'Por Isabel Harari (Repórter Brasil), Andrés Bermúdez Liévano (CLIP), Kuek Ser Kuang Keng e Jelter Meers (Pulitzer Center) | Edição Diego Junqueira',
    date: '30-10-2025',
    link_es:
      'https://reporterbrasil.org.br/2025/10/clientes-acionistas-sigma-suspeitas-litio-zero-carbono/',
    link_pt:
      'https://reporterbrasil.org.br/2025/10/clientes-acionistas-sigma-suspeitas-litio-zero-carbono/',
    link_en:
      'https://reporterbrasil.org.br/2025/10/clientes-acionistas-sigma-suspeitas-litio-zero-carbono/',
  },
  {
    image: IMG05,
    title: 'notes.notes.title5',
    description: 'notes.notes.description5',
    author: 'Isabel Harari (Repórter Brasil)',
    date: '28-10-2025',
    link_es:
      'https://www.elclip.org/la-fiebre-del-litio-avanza-hacia-la-amazonia-brasilena/',
    link_pt:
      'https://www.elclip.org/la-fiebre-del-litio-avanza-hacia-la-amazonia-brasilena/?lang=pt',
    link_en:
      'https://www.elclip.org/la-fiebre-del-litio-avanza-hacia-la-amazonia-brasilena/?lang=en',
  },
  {
    image: IMG06,
    title: 'notes.notes.title6',
    description: 'notes.notes.description6',
    author: 'Thelma Gómez Durán (Quinto Elemento Lab)',
    date: '29-10-2025',
    link_es:
      'https://www.elclip.org/el-litio-en-mexico-de-la-ilusion-a-la-incertidumbre/',
    link_pt:
      'https://www.elclip.org/el-litio-en-mexico-de-la-ilusion-a-la-incertidumbre/',
    link_en:
      'https://www.elclip.org/el-litio-en-mexico-de-la-ilusion-a-la-incertidumbre/?lang=en',
  },
  {
    image: IMG07,
    title: 'notes.notes.title7',
    description: 'notes.notes.description7',
    author: 'Rocío Lloret Céspedes - La Región / Dialogue Earth',
    date: '06-10-2025',
    link_es:
      'https://www.elclip.org/los-convenios-secretos-del-litio-boliviano/',
    link_pt:
      'https://www.elclip.org/los-convenios-secretos-del-litio-boliviano/',
    link_en:
      'https://www.elclip.org/los-convenios-secretos-del-litio-boliviano/?lang=en',
  },
  {
    image: IMG08,
    title: 'notes.notes.title8',
    description: 'notes.notes.description8',
    author: 'Maria Teresa Ronderos, Luisa Fernanda López, Iván Ruiz (CLIP)',
    date: '30-10-2024',
    link_es:
      'https://www.elclip.org/las-grietas-del-litio-documental/',
    link_pt:
      'https://www.elclip.org/las-grietas-del-litio-documental/',
    link_en:
      'https://www.elclip.org/las-grietas-del-litio-documental/',
  },
  {
    image: IMG09,
    title: 'notes.notes.title9',
    description: 'notes.notes.description9',
    author: 'María Paula Gaido, Edgardo Litvinoff y Julio Carrizo (Red Ruido)',
    date: '30-10-2024',
    link_es:
      'https://www.elclip.org/trapiche-el-rio-que-se-seca-por-el-litio/',
    link_pt:
      'https://www.elclip.org/trapiche-el-rio-que-se-seca-por-el-litio/',
    link_en:
      'https://www.elclip.org/trapiche-el-rio-que-se-seca-por-el-litio/?lang=en',
  },
  {
    image: IMG10,
    title: 'notes.notes.title10',
    description: 'notes.notes.description10',
    author: 'Iván Paredes Tamayo y Roberto Navia Gabriel (Revista Nómadas)',
    date: '30-10-2024',
    link_es:
      'https://www.elclip.org/el-oro-blanco-que-seca-la-tierra/',
    link_pt:
      'https://www.elclip.org/el-oro-blanco-que-seca-la-tierra/',
    link_en:
      'https://www.elclip.org/el-oro-blanco-que-seca-la-tierra/',
  },
]
